var process = require("../shim/process.js");
const config = require("../config.js");
var {
  Dedupe
} = require("./sentryLogger.js");
let sentry;
if (config.isNode && process.env.IS_PROD) {
  sentry = (true ? require : undefined)("@sentry/node");
  const env = process.env;
  const sentryTags = {};
  const entryScriptPath = process.argv[1];
  let componentName = "unknown";
  componentName = entryScriptPath.includes("server-manager") ? "server-manager" : entryScriptPath.includes("serverGateway") ? "gateway" : entryScriptPath.includes("serverSocial") ? "social" : entryScriptPath.includes("serverEditor") ? "editor" : entryScriptPath.includes("api.js") ? "api" : entryScriptPath.includes("server.js") ? "game-server" : entryScriptPath;
  if (env.VULTR_IP !== undefined) {
    sentryTags.ip = env.VULTR_IP;
  }
  if (env.VULTR_REGION !== undefined) {
    sentryTags.region = env.VULTR_REGION;
  }
  if (env.VULTR_INDEX !== undefined) {
    sentryTags.index = env.VULTR_INDEX;
  }
  sentryTags.component = componentName;
  sentry.init({
    environment: process.env.VULTR_SCHEME || "local",
    dsn: process.env.SENTRY_DSN,
    release: (config.gameVersion || "default") + " " + (config.customBuildVersion || config.buildVersion),
    initialScope: {
      tags: sentryTags
    },
    ignoreErrors: ["400 Bad Request error occurred", "ECONNREFUSED", "ECONNRESET", "ENETUNREACH", "Internal Server Error", "Request failed with status code 400", "Request timed out"],
    integrations: [new Dedupe()]
  });
}
function f2100(p15687, p15688, p15689) {
  p15687.withScope(p15690 => {
    if (p15688) {
      for (let v12691 in p15688) {
        let v12692;
        try {
          v12692 = JSON.stringify(p15688[v12691]);
        } catch (e170) {
          v12692 = p15688[v12691];
        }
        p15690.setExtra(v12691, v12692);
      }
    }
    p15689();
  });
}
module.exports = {
  capture(p15691) {
    if (sentry) {
      sentry.captureException(p15691);
    }
    console.warn("UNCAUGHT EXCEPTION:", p15691);
  },
  warn(p15692, p15693 = null) {
    if (sentry) {
      f2100(sentry, p15693, () => sentry.captureMessage(p15692));
    }
    console.warn("WARNING:", p15692, p15693);
  }
};